declare namespace $ {

	type $mol_grid__records_shm_wordstat_table_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['records'] >
		,
		ReturnType< $mol_grid['records'] >
	>
	type $mol_grid__col_ids_shm_wordstat_table_2 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['col_ids'] >
		,
		ReturnType< $mol_grid['col_ids'] >
	>
	type $mol_grid__col_head_content_shm_wordstat_table_3 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['col_head_content'] >
		,
		ReturnType< $mol_grid['col_head_content'] >
	>
	type $mol_grid__cell_content_shm_wordstat_table_4 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['cell_content'] >
		,
		ReturnType< $mol_grid['cell_content'] >
	>
	type $mol_grid__cell_content_text_shm_wordstat_table_5 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['cell_content'] >
		,
		ReturnType< $mol_grid['cell_content_text'] >
	>
	type $mol_grid__Cell_shm_wordstat_table_6 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['Cell'] >
		,
		ReturnType< $mol_grid['Cell'] >
	>
	type $mol_grid__Col_head_shm_wordstat_table_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['Col_head'] >
		,
		ReturnType< $mol_grid['Col_head'] >
	>
	type $mol_grid_cell__sub_shm_wordstat_table_8 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['cell_content'] >
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_grid_cell__style_shm_wordstat_table_9 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_wordstat_table['cell_width'] >,
			'minWidth': ReturnType< $shm_wordstat_table['cell_width'] >,
			'maxWidth': ReturnType< $shm_wordstat_table['cell_width'] >,
		})  & ReturnType< $mol_grid_cell['style'] >
		,
		ReturnType< $mol_grid_cell['style'] >
	>
	type $mol_float__sub_shm_wordstat_table_10 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['col_head_content'] >
		,
		ReturnType< $mol_float['sub'] >
	>
	type $mol_float__style_shm_wordstat_table_11 = $mol_type_enforce<
		({ 
			'width': ReturnType< $shm_wordstat_table['col_width'] >,
			'minWidth': ReturnType< $shm_wordstat_table['col_width'] >,
			'maxWidth': ReturnType< $shm_wordstat_table['col_width'] >,
		})  & ReturnType< $mol_float['style'] >
		,
		ReturnType< $mol_float['style'] >
	>
	type $mol_link__external_shm_wordstat_table_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_link['external'] >
	>
	type $mol_link__uri_shm_wordstat_table_13 = $mol_type_enforce<
		ReturnType< $shm_wordstat_table['cell_link_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_shm_wordstat_table_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_wordstat_table extends $mol_view {
		records( ): Record<string, any>
		col_ids( ): readonly(any)[]
		col_head_content( id: any): readonly(any)[]
		cell_content( id: any): readonly(any)[]
		Grid( ): $mol_grid
		cell_width( id: any): string
		col_width( id: any): string
		cell_link_uri( id: any): string
		table( ): any
		sub( ): readonly(any)[]
		Cell( id: any): $mol_grid_cell
		Col_head( id: any): $mol_float
		Cell_link( id: any): $mol_link
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map